import {
    createMutatorApi,
    ensureArray,
    Mutation,
    Transformer,
} from "@buurman/commons";
import { lensPath, set } from "ramda";
import { JsonApi } from "./JsonApi";

export type Value<T> = T | null;

export const initialValue: Value<any> = null;

export const types = {
    SET: "SET",
    TRANSFORM: "TRANSFORM",
};

export const reducer = <T>(
    value: Value<T> = initialValue as Value<T>,
    { type, payload }: Mutation,
) => {
    switch (type) {
        default:
            return value;

        case types.SET:
            return payload;

        case types.TRANSFORM:
            return payload(value);
    }
};

const JsonMutator = <T>(getApi: () => JsonApi<T>) => {
    const { createMutator, applyMutations } = createMutatorApi(getApi, reducer);

    return {
        applyMutations,
        mutations: {
            set: createMutator<Value<T>>(types.SET),
            transform: createMutator<Transformer<Value<T>>>(types.TRANSFORM),
            setProperty: createMutator(
                types.TRANSFORM,
                <TPropertyValue>(
                    property: string | string[],
                    value: TPropertyValue,
                ) => {
                    const lens = lensPath(ensureArray(property));
                    return (current: T) => set(lens, value, current);
                },
            ),
        },
    };
};

export default JsonMutator;
